/**
 * Resolves once main.js bootstrap has finished its initial refresh-token
 * attempt (success or failure). Router guard awaits this before reading
 * isAuthenticated, so the first navigation never races bootstrap.
 */
let _resolve;
export const sessionReady = new Promise((resolve) => {
	_resolve = resolve;
});

export const markSessionReady = () => _resolve();
